import { AccordionLargeTextDisplay } from "./AccordionLargeTextDisplay";

export default AccordionLargeTextDisplay;
